export const SET_PAGER = 'SET_PAGER'
export const STORE_PAGER = 'nutrition/pager'
export const SET_NUTRITION = 'SET_NUTRITION'
export const RESET_NUTRITION = 'RESET_NUTRITION'
export const SET_MEALPLANS = 'SET_MEALPLANS'
export const SET_NUTRITION_HABITS = 'SET_NUTRITION_HABITS'
export const SET_NUTRITION_HABIT = 'SET_NUTRITION_HABIT'
export const RESET_HABIT = 'RESET_HABIT'
export const SET_HABIT_DATA = 'SET_HABIT_DATA'
export const SET_HABIT_ICONS = 'SET_HABIT_ICONS'
